"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useVideoElementDatadogMetrics = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = require("react");
var _StudioLogger = require("@studio/logger/StudioLogger");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var logger = new _StudioLogger.StudioLogger('studio-video-player');
var useVideoElementDatadogMetrics = exports.useVideoElementDatadogMetrics = function useVideoElementDatadogMetrics(videoRef, source, performance) {
  var _source$value;
  var title = source.title,
    ext = source.ext;
  var payload = {
    title: title,
    ext: ext,
    videoId: (_source$value = source.value) === null || _source$value === void 0 ? void 0 : _source$value.eventDocId
  };
  var _useState = (0, _react.useState)({
      videoPlayTriggerTime: null,
      seekStartTime: null
    }),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    videoPlayerMetrics = _useState2[0],
    setVideoPlayerMetrics = _useState2[1];

  /**
   * Set videoPlayTriggerTime to now()
   * This is roughly equivalent to the time when user clicks "Show" button on a
   * video to put it on stage to play
   */
  if (videoPlayerMetrics.videoPlayTriggerTime == null) {
    var videoPlayTriggerTime = performance.now();
    setVideoPlayerMetrics(function (prevMetrics) {
      return _objectSpread(_objectSpread({}, prevMetrics), {}, {
        videoPlayTriggerTime: videoPlayTriggerTime
      });
    });
  }
  (0, _react.useEffect)(function () {
    if (!videoRef.current) {
      return;
    }
    var videoElement = videoRef.current;
    var onSeeking = function onSeeking() {
      var seekStartTime = performance.now();
      setVideoPlayerMetrics(function (prevMetrics) {
        return _objectSpread(_objectSpread({}, prevMetrics), {}, {
          seekStartTime: seekStartTime
        });
      });
    };

    /**
     * onSeeked is used for both initial load and forward/backward seeks afterwords
     * Reason we are using onSeeked instead onPlay is that onSeeked seems to be more reliable
     * Even for initial play (when user puts video on stage for the first time or video previously
     * put on stage starts playing after page reload), onSeeking and onSeeked are called
     */
    var onSeeked = function onSeeked() {
      var seekEndTime = performance.now();
      if (videoPlayerMetrics.videoPlayTriggerTime && videoPlayerMetrics.videoPlayTriggerTime !== -1) {
        var initialLoadDuration = seekEndTime - videoPlayerMetrics.videoPlayTriggerTime;

        /**
         * Set videoPlayTriggerTime to -1 to indicate that we have handled the initial load
         * and now we'll only consider seekTime
         */
        var _videoPlayTriggerTime = -1;
        setVideoPlayerMetrics(function (prevMetrics) {
          return _objectSpread(_objectSpread({}, prevMetrics), {}, {
            videoPlayTriggerTime: _videoPlayTriggerTime
          });
        });
        logger.info('video player metrics', _objectSpread(_objectSpread({}, payload), {}, {
          initialLoadTime: initialLoadDuration
        }));
      } else {
        var seekDuration = seekEndTime - videoPlayerMetrics.seekStartTime;
        logger.info('video player metrics', _objectSpread(_objectSpread({}, payload), {}, {
          seekTime: seekDuration
        }));
      }
    };
    videoElement.addEventListener('seeked', onSeeked);
    videoElement.addEventListener('seeking', onSeeking);
    return function () {
      videoElement.removeEventListener('seeking', onSeeking);
      videoElement.removeEventListener('seeked', onSeeked);
    };
  }, [videoPlayerMetrics.videoPlayTriggerTime, videoPlayerMetrics.seekStartTime]);
};